import { createElement, styled, composedProps } from '@vebox/etui-system';

const H6Element = createElement('h6');
const H6 = styled(H6Element)(composedProps);

export { H6 };
